import React from 'react';
import { SEO } from '../components/SEO';
import { breadcrumbSchema } from '../utils/structuredData';
import { ArrowLeftIcon } from 'lucide-react';
export function ImpressumPage() {
  const breadcrumbs = [{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }, {
    name: 'Legal Notice',
    url: 'https://close-crm-agentur.de/legal-notice'
  }];
  const structuredData = [breadcrumbSchema(breadcrumbs)];
  return <>
      <SEO title="Legal Notice" description="Legal Notice of the Close CRM Agency - Legal information and contact details." canonical="https://close-crm-agentur.de/legal-notice" noindex={true} structuredData={structuredData} data-id="element-469" data-mp="29zsy5usmjwc9" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-470" data-mp="2et48w70k4x9g">
        {/* Header */}
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-471" data-mp="2srlu9y2zpxo7">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-472" data-mp="2os35usbyn4gm">
            <div className="flex items-center justify-center sm:justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-473" data-mp="1u6rvsvpfeyau">
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0" aria-label="Close CRM Agency Homepage" data-id="element-474" data-mp="1y8wn3nsejiub">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-475" data-mp="286b2rl6i43lk">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-476" data-mp="2d4mdrz8j8k5d">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-477" data-mp="2lxpo3ynvsgvs">
                  Close CRM Agency
                </span>
              </a>
              <a href="/" className="hidden sm:flex items-center justify-center gap-2 text-gray-400 hover:text-white transition-colors text-sm flex-shrink-0" data-id="element-478" data-mp="2qydeqj876vph">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-479" data-mp="2b6kpsaqb5d28" />
                Back to Homepage
              </a>
            </div>
          </nav>
        </header>

        {/* Main Content */}
        <main className="pt-24 pb-16" data-id="element-480" data-mp="265dj6ezwijx5">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-481" data-mp="2kww852aqnosn">
            <div className="prose prose-invert prose-lg max-w-none" data-id="element-482" data-mp="2ky7b4zwd0sip">
              <h1 className="text-4xl font-bold text-white mb-8" data-id="element-483" data-mp="2g433eef9sggk">
                Legal Notice
              </h1>

              <div className="space-y-8 text-gray-300" data-id="element-484" data-mp="2tz5gblijb62v">
                <section data-id="element-485" data-mp="2oyr9g6so626f">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-486" data-mp="2oxg0lskda48g">
                    Address
                  </h2>
                  <p className="leading-relaxed" data-id="element-487" data-mp="33t5q40orgzhx">
                    CRM Kraft LLC
                    <br data-id="element-488" data-mp="2ywx5i7rsoe3d" />
                    Represented by: Justus Kraft
                    <br data-id="element-489" data-mp="19i0hehythwvq" />
                    7901 4th St. N, Ste. 300
                    <br data-id="element-490" data-mp="14inuxybuyrto" />
                    St. Petersburg, FL 33702
                    <br data-id="element-491" data-mp="14kh5vpti7y7h" />
                    United States of America
                  </p>
                </section>

                <section data-id="element-492" data-mp="3l4b31ki4hgil">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-493" data-mp="3l3j4q1x554om">
                    Contact
                  </h2>
                  <p className="leading-relaxed" data-id="element-494" data-mp="36f54lyr3zubr">
                    Phone:{' '}
                    <a href="tel:+491745444423" className="text-[#0ea5e9] hover:underline" data-id="element-495" data-mp="3bdpvv8odv3o2">
                      +49 174 5444423
                    </a>
                    <br data-id="element-496" data-mp="31i4xdkiiwlj2" />
                    Email:{' '}
                    <a href="mailto:justus@crm-kraft.de" className="text-[#0ea5e9] hover:underline" data-id="element-497" data-mp="2nhbyyop3p6ao">
                      justus@crm-kraft.de
                    </a>
                  </p>
                </section>

                <section data-id="element-498" data-mp="qoij48x0wqb7">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-499" data-mp="qosekc0u7poa">
                    EU Dispute Resolution
                  </h2>
                  <p className="leading-relaxed" data-id="element-500" data-mp="2mqvrfd7q31bu">
                    The European Commission provides a platform for online
                    dispute resolution (OS):{' '}
                    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-501" data-mp="2dpxn0ttdgrsq">
                      https://ec.europa.eu/consumers/odr/
                    </a>
                    . You can find our email address above in the legal notice.
                  </p>
                </section>

                <section data-id="element-502" data-mp="1q1o17rw5s41l">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-503" data-mp="1q2fnud7s2rfq">
                    Consumer Dispute Resolution/Universal Arbitration Board
                  </h2>
                  <p className="leading-relaxed" data-id="element-504" data-mp="1g3i5xt4uxw5p">
                    We are not willing or obliged to participate in dispute
                    resolution proceedings before a consumer arbitration board.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </main>

        {/* Footer */}
        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8" data-id="element-505" data-mp="5koltz43zlr0">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-506" data-mp="9l8kx888szfs">
            <p className="text-gray-600 text-sm" data-id="element-507" data-mp="390c8qs8m10nc">
              © {new Date().getFullYear()} Close CRM Agency. All rights
              reserved.
            </p>
          </div>
        </footer>
      </div>
    </>;
}